/*eslint-disable*/
import React, { useState, useEffect } from "react";

import APIClient from "../client";
import config from "../config.js";
import TableSearchChart from "../components/Charts/TableSearchChart.js";
import AuthNavbar from "../components/Navbars/AuthNavbar.js";

import '../assets/styles/App.css';
import '../assets/styles/tailwind.css';
import "@fontsource/montserrat";


const client = new APIClient(config);


export default function AdminActivityLog() {
    const [data, setData] = useState(null);
    const [columnData, setColumnData] = useState(null);

    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        fetchImportLog();
    }, []);

    const fetchImportLog = () => {
        client.getActivityLog().then((data) => {
            setData(data['data']['data']);
            const columns = [
                {
                    name: "Endpoint",
                    width: "250px",
                    sortable: true,
                    selector: (row) => row.activity_endpoint,
                },
                {
                    name: "Event",
                    width: "100px",
                    sortable: true,
                    selector: (row) => row.activity_event,
                },
                {
                    name: "User",
                    width: "200px",
                    sortable: true,
                    selector: (row) => row.activity_user.email,
                },
                {
                    name: "Previous Value",
                    width: "200px",
                    selector: (row) => row.previous_value,
                },

                {
                    name: "New Value",
                    width: "200px",
                    selector: (row) => row.current_value,
                },
                {
                    name: "Event Date",
                    sortable: true,
                    selector: (row) => row.logCreatedAt,
                },
            ];

            setColumnData(columns);
            setLoading(false);
            setError(null);
        });
    };

    const screenSize = (window.innerWidth >= 912);
    const screenSizeTwo = (window.innerWidth >= 1024);

    document.title = "Activity Log";

    return (
        <>
            <section>
                <AuthNavbar />
            </section>

            <section className="relative grad-1 pb-20">
                <div className="container relative mx-auto pt-12 px-4 w-10/12">

                    {loading && (
                        <div className="text-xl font-medium">Loading...</div>
                    )}
                    {error && <CardError message={error} />}

                    {data && (

                        <>
                            <h2 className="text-36 text-yellow mb-6">User Activity Log</h2>

                            <TableSearchChart
                                columns={columnData}
                                data={data}
                                defaultSortFieldId={6}
                            />

                        </>


                    )}

                </div>

            </section>

        </>
    );
}

